var _excluded = ["className", "href", "title", "children", "linktype", "dataCy", "ariaLabel", "onClick", "linksTarget", "openInSameTab", "style", "onMouseEnter", "onMouseLeave", "ariaLabelledbyId"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from 'react';
import { Link } from 'react-router-dom';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { getGlobalDictionaryTerm } from '../../../utils';
var RouterLink = function RouterLink(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    href = _ref.href,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    children = _ref.children,
    _ref$linktype = _ref.linktype,
    linktype = _ref$linktype === void 0 ? 'internal' : _ref$linktype,
    _ref$dataCy = _ref.dataCy,
    dataCy = _ref$dataCy === void 0 ? '' : _ref$dataCy,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    _onClick = _ref.onClick,
    linksTarget = _ref.linksTarget,
    _ref$openInSameTab = _ref.openInSameTab,
    openInSameTab = _ref$openInSameTab === void 0 ? false : _ref$openInSameTab,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    ariaLabelledbyId = _ref.ariaLabelledbyId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var sitecoreContext = useSitecoreContext();
  var finalLabel = ariaLabel ? ariaLabel : title;
  var conditionalProps = finalLabel ? {
    'aria-label': finalLabel
  } : {};
  if (ariaLabelledbyId) {
    conditionalProps['aria-labelledby'] = ariaLabelledbyId;
  }
  if (linktype && linktype !== 'internal' || href && href.startsWith('http') || linksTarget === '_blank') {
    var finalTarget = linksTarget ? linksTarget : openInSameTab ? '_self' : '_blank';
    if (finalTarget === '_blank') {
      var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
      finalLabel = finalLabel ? "".concat(finalLabel, " | ").concat(newWindowLabel) : newWindowLabel;
      conditionalProps['aria-label'] = finalLabel;
    }
    return /*#__PURE__*/React.createElement("a", _extends({
      className: className,
      href: href,
      target: finalTarget,
      rel: "noopener noreferrer",
      "data-cy": dataCy,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: style,
      onClick: function onClick() {
        if (_onClick) {
          _onClick();
        }
      }
    }, otherProps, conditionalProps), children);
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: className,
    to: href,
    "data-cy": dataCy,
    style: style,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    }
  }, otherProps, {
    ref: otherProps.ref
  }, conditionalProps), children);
};
export default RouterLink;